import { createContext } from 'react';
import type { ControlClientMessage, ControlMessage } from '@/contracts';

export type WebSocketContextValue = {
  connected: boolean;
  sendMessage: (message: ControlClientMessage) => boolean;
  addMessageListener: (listener: (message: ControlMessage) => void) => () => void;
  lastMessage?: ControlMessage;
  error?: string | null;
};

export const WebSocketContext = createContext<WebSocketContextValue | null>(null);
